/**
 * ShopList Component
 * --
 * 작성자 - Owen
 * 작성일 - 2025 07 11 금요일
 * 마지막 수정일 - 2025 07 11 금요일
 */
import { Flex, Input, Spin } from 'antd';
import { Text } from 'components';
import React from 'react';

const ShopList = (props) => {
  /**
   * SECTION - Init
   */

  /**!SECTION - Init */

  /**
   * SECTION - Props
   */
  const { data = [], selected = null, onSelect = () => {} } = props;
  /**!SECTION - Props */

  /**
   * SECTION - Route
   */

  /**!SECTION - Route */

  /**
   * SECTION - Variable
   */
  const styles = {
    layout: {
      padding: '10px 4px',
    },
    list: {},
    item: {
      padding: '12px 20px',
      margin: 4,
      cursor: 'pointer',
      border: '1px solid #FFFFFF',
      borderRadius: 8,
    },
    active: {
      backgroundColor: '#E7F6FF',
      borderColor: '#78C7FF',
    },
    inActive: {
      borderColor: '#FFFFFF',
      backgroundColor: '#FFFFFF',
    },
  };
  /**!SECTION - Variable */

  /**
   * SECTION - Query Data
   */

  /**!SECTION - Query Data */

  /**
   * SECTION - Mutate
   */

  /**!SECTION - Mutate */

  /**
   * SECTION - State
   */
  const [searchValue, setSearchValue] = React.useState('');
  const [filteredData, setFilteredData] = React.useState([]);
  /**!SECTION - State */

  /**
   * SECTION - Function
   */

  /**!SECTION - Function */

  /**
   * SECTION - Hooks
   */
  React.useEffect(() => {
    if (!searchValue) {
      setFilteredData(data);
    } else {
      setFilteredData(
        data.filter((_item) =>
          _item.shop_information_name.includes(searchValue)
        )
      );
    }
  }, [searchValue, data]);
  /**!SECTION - Hooks */

  /**
   * SECTION - Render
   */

  if (!data.length) {
    return (
      <Flex
        style={{ ...styles.layout, height: '100%' }}
        justify="center"
        align="center"
      >
        <Spin></Spin>
      </Flex>
    );
  }

  return (
    <Flex vertical>
      <Flex
        style={{
          ...styles.layout,
          position: 'sticky',
          top: 0,
          background: '#FFFFFF',
        }}
      >
        <Input
          size="large"
          placeholder="업체명을 입력해주세요"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          allowClear
        />
      </Flex>
      <Flex vertical gap={2} style={styles.list}>
        {filteredData
          .toSorted((a, b) => a.shop_information_id - b.shop_information_id)
          .map((_item) => (
            <Flex
              key={`shop_${_item.shop_information_id}`}
              gap={4}
              vertical
              style={{
                ...styles.item,
                ...(_item.shop_information_id === selected
                  ? styles.active
                  : styles.inActive),
              }}
              flex={1}
              onClick={() => {
                onSelect(_item.shop_information_id);
              }}
            >
              <Text size={14} weight={500}>
                {_item.shop_information_name}
              </Text>
              <Text size={12} color={'#BDBDBD'}>
                {_item.mall_information?.business_num ?? '-'}
              </Text>
            </Flex>
          ))}
      </Flex>
    </Flex>
  );
  /**!SECTION - Render */
};

export default ShopList;
